import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, IIctRiskExposure } from 'store/ducks/Reportings/types';
import { columnsRiskExposure } from 'constants/reportColumns';

const RiskExposure: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<IIctRiskExposure[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());

    try {
      const fetchedData = await reportingOp.getICTExposure(entityIds[0], date);

      const riskExposure = fetchedData?.risk_exposure ?? [];

      const formattedData: IIctRiskExposure[] = riskExposure.flatMap(
        (item: any) => {
          const base = {
            dependency_type_description: item.dependency_type_description,
            dependency_type_name: item.dependency_type_name,
            entity_end_date: item.entity_end_date,
            entity_name: item.entity_name,
            entity_reporting_date: item.entity_reporting_date,
            entity_start_date: item.entity_start_date,

            exposure_category_description: item.exposure_category_description,
            exposure_category_name: item.exposure_category_name,

            ict_risk_name: item.ict_risk_name,

            ict_system_end_date: item.ict_system_end_date,
            ict_system_name: item.ict_system_name,
            ict_system_start_date: item.ict_system_start_date,

            risk_exposure_description: item.risk_exposure_description,
            risk_exposure_end_date: item.risk_exposure_end_date,
            risk_exposure_name: item.risk_exposure_name,
            risk_exposure_start_date: item.risk_exposure_start_date,
          };

          const services = item.services ?? [];

          if (services.length > 0) {
            return services.map((service: any) => ({
              ...base,

              contract_name: service.contract_name ?? null,
              ict_service_name: service.ict_service_name ?? null,
              tpp_name: service.tpp_name ?? null,

              contract_id: service.contract_id ?? null,
              ict_service_id: service.ict_service_id ?? null,
              tpp_id: service.tpp_id ?? null,
            }));
          }

          return [
            {
              ...base,

              contract_name: null,
              ict_service_name: null,
              tpp_name: null,

              contract_id: null,
              ict_service_id: null,
              tpp_id: null,
            },
          ];
        },
      );

      setData(formattedData);
    } catch (error) {
      console.error('Error fetching ict risk source:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table
      columns={columnsRiskExposure}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default RiskExposure;
